import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

/** Figma's "Notification Center", in the app's sentence case. */
export const ALERTS_CENTER_TITLE = 'Notification center';

interface IAlertsCenterHeaderProps {
  title: string;
  /** The chevron glyph — points where the card is about to go. */
  icon: React.ComponentType<{ className?: string }>;
  /** Accessible name for the chevron button. */
  collapseLabel: string;
  onCollapse: () => void;
  /** The chevron button, for a host that moves focus onto it. */
  collapseButtonRef?: React.Ref<HTMLButtonElement>;
  className?: string;
}

/**
 * The card's header: the title with the chevron that collapses the card. Pinned
 * — it sits outside the list's scroll container, so the collapse affordance
 * stays reachable however far the user has scrolled, and it renders in every
 * state including the error one.
 */
const AlertsCenterHeader = ({
  title,
  icon: Icon,
  collapseLabel,
  onCollapse,
  collapseButtonRef,
  className,
}: IAlertsCenterHeaderProps) => (
  <div className={cx('flex shrink-0 items-center justify-between gap-2 px-4', className)}>
    <div className="text-primary min-w-0 flex-1 truncate text-lg font-medium">{title}</div>
    <button
      ref={collapseButtonRef}
      type="button"
      aria-label={collapseLabel}
      aria-expanded="true"
      onClick={onCollapse}
      className="text-utility-mist-700 hover:bg-primary_hover outline-focus-ring flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-lg p-2 transition duration-100 ease-linear focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      <Icon aria-hidden="true" className="size-5 shrink-0" />
    </button>
  </div>
);

export default AlertsCenterHeader;
